import React from 'react';
import { AlertNote } from 'venn-ui-kit';

export const IndividualBenchmarkAlert = () => (
  <AlertNote size="small">
    This view’s output may look different for other users based on their benchmark assignments in Analysis.
  </AlertNote>
);
